import { Button } from '@ps/sports-ui-component-library';
import React from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import Loader from '@swf/components/StarsButton/components/Loader/Loader';
import Translation from '@swf/components/Translation/Translation';
import useTrackers from '@swf/core/hooks/useTrackers';
import useTrackingLabel from '@swf/core/hooks/useTrackingLabel';
import { select } from '@swf/core/store';
import useBetSlip from '@swf/sports/hooks/useBetSlip';

import useTotals from '../../../../../../../../hooks/useTotals';
import { getIsDailyMaxPayoutLimitReached } from '../../../../../../../../utils/isDailyMaxPayoutLimitReached';

import { TXTWCL_Place_Bet } from './PlaceBetButton.messages.json';

const PlaceBetButton: React.FC = () => {
  const { totalStake, totalPotentialReturns } = useTotals();
  const { betSlip } = useBetSlip();
  const opportunities = useSelector(select.betSlip.singleOpportunities);
  const dailyMaxPayoutLimit = useSelector(select.betSlip.dailyMaxPayoutLimit);
  const fetchStatus = useSelector(select.betSlip.fetchStatus);
  const selectedPromotionPicker = useSelector(select.betSlip.selectedPromotionPicker);
  const buttonName = useTrackingLabel(TXTWCL_Place_Bet);
  const { buttonPressed } = useTrackers();
  const { getState } = useForm();
  const { submitting: isSubmitting } = useFormState();
  const { hasValidationErrors } = getState();

  const hasNoBettableOpportunities = opportunities.every((opp) =>
    ['SUSPENDED', 'UNAVAILABLE'].includes(opp.status)
  );
  const isDailyMaxPayoutLimitReached = getIsDailyMaxPayoutLimitReached(
    dailyMaxPayoutLimit,
    totalPotentialReturns
  );
  const isDisabled =
    betSlip.length === 0 ||
    hasNoBettableOpportunities ||
    !totalStake ||
    hasValidationErrors ||
    fetchStatus === 'AUTH_UPDATE_PENDING' ||
    isDailyMaxPayoutLimitReached ||
    Boolean(selectedPromotionPicker);

  return (
    <Button type="submit" onClick={() => buttonPressed({ buttonName })} disabled={isDisabled}>
      {isSubmitting ? <Loader /> : <Translation {...TXTWCL_Place_Bet} />}
    </Button>
  );
};

export default PlaceBetButton;
